function expandHex(color: string) {
  if (/^#[0-9a-f]{3}$/i.test(color)) {
    return `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`;
  }
  return /^#[0-9a-f]{6}$/i.test(color) ? color : null;
}

function mixHexColor(color: string, target: number, factor: number) {
  const hex = expandHex(color);
  if (!hex) return color;

  const amount = Math.max(0, Math.min(1, factor));
  const channels = [1, 3, 5].map((index) => parseInt(hex.slice(index, index + 2), 16));
  const mixed = channels.map((channel) =>
    Math.round(channel + (target - channel) * amount)
      .toString(16)
      .padStart(2, "0"),
  );
  return `#${mixed.join("")}`;
}

export const lightenHexColor = (color: string, factor: number) => mixHexColor(color, 255, factor);
export const darkenHexColor = (color: string, factor: number) => mixHexColor(color, 0, factor);
